var map = {
	"./en/404.json": "1ute",
	"./en/about.json": "hWMF",
	"./en/bio.json": "LCbf",
	"./en/blog.json": "cFPh",
	"./en/buttons.json": "B+Lc",
	"./en/index.json": "pT45",
	"./en/navigation.json": "ubTU",
	"./ru/404.json": "Mdt0",
	"./ru/about.json": "Px11",
	"./ru/bio.json": "Lts6",
	"./ru/blog.json": "cVt2",
	"./ru/buttons.json": "cM98",
	"./ru/index.json": "h6aH",
	"./ru/navigation.json": "i2Fz"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "EL3+";